import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#282C30] py-8 px-4" data-testid="site-footer">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 font-mono text-xs uppercase tracking-widest text-[#606872]">
        <div>© {new Date().getFullYear()} Clawback · read-only email · never touches your money</div>
        <nav className="flex items-center gap-5">
          <Link to="/privacy" className="hover:text-[#F4F1EA] transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-[#F4F1EA] transition-colors" data-testid="footer-terms-link">Terms of Service</Link>
          <a href="mailto:support@refundbot.org" className="hover:text-[#F4F1EA] transition-colors" data-testid="footer-contact-link">Contact</a>
        </nav>
      </div>
    </footer>
  );
}
